<form [formGroup]="currentForm" class="ur-form-container">
  <div class="mb-3">
    <strong>Ultimate Remitter {{ titleSuffix }}</strong>
  </div>

  <div class="ur-form">
    <div class="form-group">
      <mat-form-field
        [ngClass]="{'is-valid': typeCtrl.valid && typeCtrl.touched,
          'is-invalid': !typeCtrl.valid && typeCtrl.touched}">
        <mat-select formControlName="type" placeholder="Type"
          (selectionChange)="typeChanged()">
          <mat-option *ngFor="let type of types" [value]="type.id">
            {{ type.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div class="error-message"
        *ngIf="!typeCtrl.valid && typeCtrl.touched">
        Please input valid information here
      </div>
    </div>

    <div class="form-group" *ngIf="isCompany">
      <mat-form-field
        [ngClass]="{'is-valid': companyNameCtrl.valid && companyNameCtrl.touched,
          'is-invalid': !companyNameCtrl.valid && companyNameCtrl.touched}">
        <input matInput placeholder="Company name" formControlName="companyName"  maxlength="35" />
      </mat-form-field>
      <div class="error-message"
        *ngIf="companyNameCtrl.hasError('required') && companyNameCtrl.touched">
        Please input valid information here
      </div>
      <div class="error-message"
        *ngIf="companyNameCtrl.hasError('maxlength') &&  companyNameCtrl.touched">
        Maximum of 35 characters
      </div>
      <div class="error-message"
        *ngIf="companyNameCtrl.hasError('pattern') && companyNameCtrl.touched">
        <np-swift-character-message></np-swift-character-message>
      </div>
    </div>

    <div class="form-group" *ngIf="isCompany">
      <mat-form-field
        [ngClass]="{'is-valid': companyNumberCtrl.valid && companyNumberCtrl.touched,
                    'is-invalid': !companyNumberCtrl.valid && companyNumberCtrl.touched}">
        <input matInput placeholder="Company number" formControlName="companyNumber" maxlength="50"/>
      </mat-form-field>
      <div class="error-message"
        *ngIf="companyNumberCtrl.hasError('required') && companyNumberCtrl.touched">
        Please input valid information here
      </div>
      <div class="error-message"
        *ngIf="companyNumberCtrl.hasError('pattern') && companyNumberCtrl.touched">
        <np-swift-character-message></np-swift-character-message>
      </div>
    </div>

    <div class="form-group" *ngIf="isIndividual">
      <mat-form-field
        [ngClass]="{'is-valid': firstNameCtrl.valid && firstNameCtrl.touched,
    'is-invalid': !firstNameCtrl.valid && firstNameCtrl.touched}">
        <input matInput placeholder="First name" formControlName="firstName" maxlength="35" />
      </mat-form-field>
      <div class="error-message"
        *ngIf="firstNameCtrl.hasError('required') && firstNameCtrl.touched">
        Please input valid information here
      </div>
      <div class="error-message"
        *ngIf="firstNameCtrl.hasError('maxlength') &&  firstNameCtrl.touched">
        Maximum of 35 characters
      </div>
      <div class="error-message"
        *ngIf="firstNameCtrl.hasError('pattern') && firstNameCtrl.touched">
        <np-swift-character-message></np-swift-character-message>
      </div>
    </div>

    <div class="form-group" *ngIf="isIndividual">
      <mat-form-field
        [ngClass]="{'is-valid': lastNameCtrl.valid && lastNameCtrl.touched,
    'is-invalid': !lastNameCtrl.valid && lastNameCtrl.touched}">
        <input matInput placeholder="Last name" formControlName="lastName" maxlength="35" />
      </mat-form-field>
      <div class="error-message"
        *ngIf="lastNameCtrl.hasError('required') && lastNameCtrl.touched">
        Please input valid information here
      </div>
      <div class="error-message"
        *ngIf="lastNameCtrl.hasError('maxlength') &&  lastNameCtrl.touched">
        Maximum of 35 characters
      </div>
      <div class="error-message"
        *ngIf="lastNameCtrl.hasError('pattern') && lastNameCtrl.touched">
        <np-swift-character-message></np-swift-character-message>
      </div>
    </div>

    <div class="form-group" *ngIf="isIndividual">
      <mat-form-field
        [ngClass]="{'is-valid': dateOfBirthCtrl.valid && dateOfBirthCtrl.touched, 'is-invalid': !dateOfBirthCtrl.valid && dateOfBirthCtrl.touched}">
        <input matInput [matDatepicker]="pickerDOB" placeholder="Date of birth" formControlName="dateOfBirth" />
        <mat-datepicker-toggle matSuffix [for]="pickerDOB"></mat-datepicker-toggle>
        <mat-datepicker panelClass="greengo" #pickerDOB></mat-datepicker>
      </mat-form-field>
      <div class="error-message"
        *ngIf="!dateOfBirthCtrl.valid && dateOfBirthCtrl.touched">
        Please input valid information here
      </div>
    </div>

    <div class="form-group">
      <mat-form-field
        [ngClass]="{'is-valid': addressCtrl.valid && addressCtrl.touched,
    'is-invalid': !addressCtrl.valid && addressCtrl.touched}">
        <input matInput placeholder="Address" formControlName="address" maxlength="35" />
      </mat-form-field>
      <div class="error-message"
        *ngIf="addressCtrl.hasError('required') && addressCtrl.touched">
        Please input valid information here
      </div>
      <div class="error-message"
        *ngIf="addressCtrl.hasError('maxlength') &&  addressCtrl.touched">
        Maximum of 35 characters
      </div>
      <div class="error-message"
        *ngIf="addressCtrl.hasError('pattern') && addressCtrl.touched">
        <np-swift-character-message></np-swift-character-message>
      </div>
    </div>

    <div class="form-group">
      <mat-form-field
        [ngClass]="{'is-valid': cityCtrl.valid && cityCtrl.touched,
            'is-invalid': !cityCtrl.valid && cityCtrl.touched}">
        <input matInput placeholder="City" formControlName="city" maxlength="50" />
      </mat-form-field>
      <div class="error-message"
        *ngIf="cityCtrl.hasError('required') && cityCtrl.touched">
        Please input valid information here
      </div>
      <div class="error-message"
        *ngIf="cityCtrl.hasError('maxlength') &&  cityCtrl.touched">
        Maximum of 50 characters
      </div>
      <div class="error-message"
        *ngIf="cityCtrl.hasError('pattern') && cityCtrl.touched">
        <np-swift-character-message></np-swift-character-message>
      </div>
    </div>

    <div class="form-group">
      <mat-form-field
        [ngClass]="{'is-valid': postCodeCtrl.valid && postCodeCtrl.touched,
            'is-invalid': !postCodeCtrl.valid && postCodeCtrl.touched}">
        <input matInput placeholder="Post code" formControlName="postCode" maxlength="12"/>
      </mat-form-field>
      <div class="error-message"
        *ngIf="postCodeCtrl.hasError('required') && postCodeCtrl.touched">
        Please input valid information here
      </div>
      <div class="error-message"
        *ngIf="postCodeCtrl.hasError('pattern') && postCodeCtrl.touched">
        <np-swift-character-message></np-swift-character-message>
      </div>
    </div>

    <div class="form-group">
      <mat-form-field
        [ngClass]="{'is-valid': stateProvinceCtrl.valid && stateProvinceCtrl.touched,
            'is-invalid': !stateProvinceCtrl.valid && stateProvinceCtrl.touched}">
        <input matInput placeholder="State or province" formControlName="stateProvince" />
      </mat-form-field>
      <div class="error-message"
        *ngIf="stateProvinceCtrl.hasError('required') && stateProvinceCtrl.touched">
        Please input valid information here
      </div>
      <div class="error-message"
        *ngIf="stateProvinceCtrl.hasError('pattern') && stateProvinceCtrl.touched">
        <np-swift-character-message></np-swift-character-message>
      </div>
    </div>

    <div class="form-group">
      <np-mat-autocomplete-hybrid
        dataDisplayValue="name" [selectControl]="countryCtrl"
        placeholder="Country" [data]="countries" (selecteOptionChanged)="changeRemitterCountry()"
        inputClass="capitalize-field"></np-mat-autocomplete-hybrid>
    </div>

    <div class="form-group">
      Will this beneficiary be used for treasury/settlement payments?
    </div>
    <div class="mx-4">
      <mat-radio-group formControlName="useForTreasuryPayments">
        <mat-radio-button disableRipple [value]="true" >Yes</mat-radio-button>
        <mat-radio-button disableRipple [value]="false">No</mat-radio-button>
      </mat-radio-group>
    </div>
  </div>
  <div *ngIf="isNew">
    <div class="row mb-3 mt-3">
      <div class="col-md-6">
          <button class="btn btn-block btn-lg btn-greengo-o" (click)="cancel()">Cancel</button>
      </div>
      <div class="col-md-6">
          <button class="btn btn-block btn-lg" [ngClass]="{
                  'btn-greengo': currentForm.valid,
                  'btn-inactive': !currentForm.valid
              }" (click)="save()">
              Save
          </button>
      </div>
    </div>
  </div>

  <div *ngIf="!isNew">
    <div class="row mb-3 mt-3">
      <div class="col-md-6">
          <button class="btn btn-block btn-lg btn-greengo-o" (click)="cancel()">Cancel</button>
      </div>
      <div class="col-md-6">
        <button class="btn btn-block btn-lg btn-lead" (click)="delete()">Delete</button>
      </div>
    </div>
  </div>
</form>
